import { useUniversalAuth } from "@west-tennessee-consulting/ui";
import type { QuickBooksEnvironment, QuickBooksConnectionStatus } from "@/lib/types/quickbooks-unified";

export type { QuickBooksConnectionStatus } from "@/lib/types/quickbooks-unified";

interface AppUserQBFields {
  quickbooks_access_token?: string | null;
  quickbooks_realm_id?: string | null;
  quickbooks_environment?: QuickBooksEnvironment | null;
}

export function useQuickBooksConnectionStatus(): {
  data: QuickBooksConnectionStatus | undefined;
  error: Error | null;
  isLoading: boolean;
} {
  const { appUser } = useUniversalAuth();

  const appUserWithQB = appUser as (typeof appUser & AppUserQBFields) | null;
  const connectionStatus: QuickBooksConnectionStatus = {
    isConnected: !!(appUserWithQB?.quickbooks_access_token && appUserWithQB?.quickbooks_realm_id),
    realmId: appUserWithQB?.quickbooks_realm_id ?? undefined,
    environment: appUserWithQB?.quickbooks_environment ?? undefined,
  };

  return {
    data: connectionStatus,
    error: null,
    isLoading: false,
  };
}

export function useQuickBooksTokens() {
  const { appUser } = useUniversalAuth();

  const appUserWithQB = appUser as (typeof appUser & AppUserQBFields) | null;
  const accessToken = appUserWithQB?.quickbooks_access_token;
  const realmId = appUserWithQB?.quickbooks_realm_id;
  const isConnected = !!(accessToken && realmId);

  return {
    data: isConnected
      ? {
          tokens: {
            access_token: accessToken,
            realmId: realmId,
          },
        }
      : undefined,
    error: isConnected ? null : new Error("QuickBooks not connected"),
    isLoading: false,
  };
}
